import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div className="loading">Nalaganje...</div>;
  }
  
  return user ? children : <Navigate to="/login" />;
}

export default PrivateRoute;